import { render, staticRenderFns } from "./JsonKpiChartCard.vue?vue&type=template&id=34b005b0&scoped=true"
import script from "./JsonKpiChartCard.vue?vue&type=script&lang=js"
export * from "./JsonKpiChartCard.vue?vue&type=script&lang=js"
import style0 from "./JsonKpiChartCard.vue?vue&type=style&index=0&id=34b005b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b005b0",
  null
  
)

export default component.exports